<template>
  <b-navbar-nav class="nav-left">
    <!-- 戻るボタン -->
    <b-navbar-nav v-if="back" class="nav-back">
      <b-nav-item @click="$emit('on-back')"><b-icon icon="chevron-left" /></b-nav-item>
    </b-navbar-nav>

    <!-- キャンセル -->
    <b-navbar-nav v-if="cancel">
      <b-nav-item @click="$emit('on-cancel')">キャンセル</b-nav-item>
    </b-navbar-nav>

    <!-- Brand -->
    <b-navbar-nav v-if="brand" class="nav-brand h-100">
      <icon-navigation-brand v-if="brand" />
    </b-navbar-nav>

    <!-- 組織選択 -->
    <b-navbar-nav v-if="domains" class="domains">
      <direct-domain-dropdown :domainId="domainId" :domains="domainList" />
    </b-navbar-nav>

    <!-- 指定アイテムを出す -->
    <b-navbar-nav v-if="leftItems && leftItems.length != 0">
      <b-nav-item
        v-for="item of leftItems"
        v-bind:key="item.label"
        @click="$emit(item.click)"
        :disabled="item.disabled"
      >
        <b-icon v-if="item.icon" :icon="item.icon" />
        <span v-else>
          {{ item.label }}
        </span>
      </b-nav-item>
    </b-navbar-nav>

    <!-- 未指定時のスペーサー -->
    <b-navbar-nav v-if="leftEmpty">
      <b-nav-item disabled class="invisible"><b-icon icon="arrow-left" /></b-nav-item>
    </b-navbar-nav>
  </b-navbar-nav>
</template>
<style>
.navbar-nav.nav-left .nav-item > .nav-link {
  color: white;
  padding-left: 0px;
}
</style>
<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { useDomainStore } from "@/store";
import DirectDomainDropdown from "./DirectDomainDropBox.vue";
import IconNavigationBrand from "../icon/IconNavigatonBrand.vue";
import type { IDirectUserInfo } from "../../direct-utility";
import { createDummyDirectUser } from "../../direct-utility";
import { useTextProcess } from "@/composables/useTextProcess";
import type { Domains } from "@/direct-access";

export type NavigationItem = { to: string; label: string; click?: string };

/**
 * ナビゲーションバー（左）
 * back       戻るボタン
 * domains    組織選択ドロップダウンボタン
 * cancel     キャンセルボタン
 * left-items 指定されたものを表示
 */
export default defineComponent({
  name: "nav-bar-left",
  components: { DirectDomainDropdown, IconNavigationBrand },
  props: {
    domainId: { type: String, default: () => "" }, // 組織選択ドロップボタンの現在の組織取得する用
    user: { type: Object as PropType<IDirectUserInfo>, default: () => createDummyDirectUser() },
    back: { type: Boolean, default: () => false }, // true:戻るボタン
    brand: { type: Boolean, default: () => false }, // true: ブランド表示
    domains: { type: Boolean, default: () => false }, // true: 組織選択ドロップダウン
    cancel: { type: Boolean, default: () => false }, // true: キャンセルボタン
    /** ナビゲーションの左側メニューアイテム。２つ以上でドロップダウンになります */
    leftItems: { type: Array as PropType<NavigationItem[]>, default: () => [] },
  },
  setup(props) {
    // 旧 TextProcessMixin → composable（1-D 利用側書き換え）
    const { katakanaToHiragana } = useTextProcess();

    const leftEmpty = computed((): boolean => {
      return (
        props.back == false &&
        props.domains == false &&
        props.cancel == false &&
        props.leftItems.length == 0
      );
    });

    // スタイル
    const navBarStyle = computed((): Record<string, unknown> => {
      return {
        height: "44pt",
      };
    });

    const domainList = computed((): Domains => {
      const domains = useDomainStore().directDomains as Domains;
      // 組織名昇順にソート(カタカナ→ひらがな、小文字にして比較)
      return domains.sort((l, r) => {
        const a = katakanaToHiragana(l.domain_name).toLowerCase();
        const b = katakanaToHiragana(r.domain_name).toLowerCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
    });

    return {
      leftEmpty,
      navBarStyle,
      domainList,
    };
  },
});
</script>
